import { render } from "./OtherResultRow.vue?vue&type=template&id=2e0d62bc&scoped=true"
import script from "./OtherResultRow.vue?vue&type=script&lang=js"
export * from "./OtherResultRow.vue?vue&type=script&lang=js"

import "./OtherResultRow.vue?vue&type=style&index=0&id=2e0d62bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0d62bc"]])

export default __exports__